import React, { Component } from 'react';
import { MEDIA_TYPE } from '_enums/media-types';
import { BASE_IMAGE_URL } from '_utils';

import Picture from '../general/Picture';

class GridItem extends Component {
  render() {
    return this.renderMediaItem();
  }

  // eslint-disable-next-line
  renderMediaItem = () => this.getGridImage();

  getGridImage = () => {
    let imageUrl;
    let showVideoThumbnail = false;
    let lightboxUrl;
    let lightboxFunc;

    let innerLightboxFunc;
    let innerlightboxUrl;

    // We loop through the images and set the image and lightbox func based on the image
    for (let index = 0; index < this.props.mediaItems.length; index++) {
      const mediaItem = this.props.mediaItems[index];

      // If we are an image item and we haven't set the image url yet
      if (mediaItem.itemType === MEDIA_TYPE.IMAGE && imageUrl === undefined) {
        imageUrl = mediaItem.url;
        lightboxUrl = mediaItem.url;
        lightboxFunc = this.props.createImageLightbox;
      }
    }

    // We loop through again only checking videos, setting the inner lightbox func for the video.
    // if there is a video and no image has been set on the previous pass
    // then we set the image to be the thumbnail of the video (first frame)
    for (let index = 0; index < this.props.mediaItems.length; index++) {
      const mediaItem = this.props.mediaItems[index];

      if (mediaItem.itemType === MEDIA_TYPE.VIDEO) {
        showVideoThumbnail = true;
        innerLightboxFunc = this.props.createVideoLightbox;
        innerlightboxUrl = mediaItem.url;

        if (imageUrl === undefined) {
          lightboxUrl = mediaItem.url;
          lightboxFunc = this.props.createVideoLightbox;

          imageUrl = mediaItem.thumbnailUrl;
        }
      }
    }

    if (this.props.backgroundMediaItem) {
      const backgroundImage = imageUrl.replace(/ /g, '%20');

      return (
        <div
          key={this.props.index}
          className="media-item media-item--image"
          onClick={e => lightboxFunc(e, lightboxUrl)}
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        >
          {showVideoThumbnail && (
            <div className="media-item-play" onClick={e => innerLightboxFunc(e, innerlightboxUrl)} />
          )}
          {this.renderCardFooter()}
        </div>
      );
    }

    return (
      <div className="media-item media-item--image" onClick={e => lightboxFunc(e, lightboxUrl)}>
        <Picture>
          <source media="(min-width: 2000px)" srcSet={`${BASE_IMAGE_URL}${imageUrl}?width=1000`} />
          <source media="(max-width: 768px)" srcSet={`${BASE_IMAGE_URL}${imageUrl}?width=768`} />
          <source media="(max-width: 1920px)" srcSet={`${BASE_IMAGE_URL}${imageUrl}?width=500`} />
          <img src={`${BASE_IMAGE_URL}${imageUrl}?width=1000`} />
        </Picture>
        {showVideoThumbnail && (
          <div className="media-item-play" onClick={e => innerLightboxFunc(e, innerlightboxUrl)} />
        )}
        {this.renderCardFooter()}
      </div>
    );
  };

  renderCardFooter() {
    if (!this.props.cultureCode || !this.props.recordedTime) {
      return null;
    }

    return (
      <div className="card-overlay-footer">
        <span className={`field field--flag flag ${this.props.cultureCode}`} />
        <span className="field field--name">
          {this.props.firstName} {this.props.lastName}
        </span>
        <span className="field field--time">{this.props.recordedTime}</span>
      </div>
    );
  }
}

export default GridItem;
